import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { LoginPage } from '@/pages/auth/Login';
import { DashboardPage } from '@/pages/dashboard/Dashboard';
import { MoviesPage } from '@/pages/movies/Movies';
import { MovieEditPage } from '@/pages/movies/MovieEdit';
import { OmdbImportPage } from '@/pages/movies/OmdbImport';
import { ShowtimesPage } from '@/pages/showtimes/Showtimes';
import { EventsPage } from '@/pages/events/Events';
import { EventEditPage } from '@/pages/events/EventEdit';
import { PagesPage } from '@/pages/pages/Pages';
import { PageEditPage } from '@/pages/pages/PageEdit';
import { MediaPage } from '@/pages/media/Media';
import { InquiriesPage } from '@/pages/inquiries/Inquiries';
import { JobsPage } from '@/pages/jobs/Jobs';
import { SettingsPage } from '@/pages/settings/Settings';
import { UsersPage } from '@/pages/users/Users';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="movies" element={<MoviesPage />} />
        <Route path="movies/import" element={<OmdbImportPage />} />
        <Route path="movies/new" element={<MovieEditPage />} />
        <Route path="movies/:id" element={<MovieEditPage />} />
        <Route path="showtimes" element={<ShowtimesPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="events/new" element={<EventEditPage />} />
        <Route path="events/:id" element={<EventEditPage />} />
        <Route path="pages" element={<PagesPage />} />
        <Route path="pages/new" element={<PageEditPage />} />
        <Route path="pages/:id" element={<PageEditPage />} />
        <Route path="media" element={<MediaPage />} />
        <Route path="inquiries" element={<InquiriesPage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="users" element={<UsersPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
